import { createContext } from 'react';

import { Shop, ShopGroup, User } from 'types';

export type OrdersContextProps = {
  shops?: Shop[];
  shopGroups?: ShopGroup[];
  traders?: User[];
  merchants?: User[];
};

export const OrdersContext = createContext<OrdersContextProps>({
  shops: [],
  shopGroups: [],
  traders: [],
  merchants: [],
});
